<template>
  <div>
    <div class="page-header">
      <div>
        <div class="page-title">用户记录</div>
        <div class="page-subtitle">用户资金变动记录管理</div>
      </div>
    </div>
    <el-card>
      <el-form class="table-filters" inline size="small">
        <el-form-item label="用户" v-if="isSuperAdmin == 1">
          <el-select v-model="filters.admin_id" placeholder="选择用户" clearable>
            <el-option
              v-for="user in users"
              :key="user.id"
              :label="user.username"
              :value="user.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="订单ID">
          <el-input v-model="filters.order_id" placeholder="订单ID" clearable />
        </el-form-item>
        <el-form-item label="订单编号">
          <el-input v-model="filters.order_no" placeholder="订单编号" clearable />
        </el-form-item>
        <el-form-item label="变动类型">
          <el-select v-model="filters.type" placeholder="全部" clearable>
            <el-option label="收入" value="1" />
            <el-option label="支出" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker v-model="filters.dateRange" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="records" stripe @sort-change="handleSortChange">
        <el-table-column prop="id" label="ID" min-width="80" sortable="custom" align="center" />
        <el-table-column prop="admin_id" label="用户ID" min-width="100" sortable="custom" align="center" />
        <el-table-column label="用户信息" min-width="100" align="left">
          <template slot-scope="scope">
            <div class="user-info">
              <div class="user-name">{{ scope.row.admin_name || '未知' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="change_money" label="变动金额" min-width="80" sortable="custom" align="right">
          <template slot-scope="scope">
            <span :style="{ color: parseFloat(scope.row.change_money) >= 0 ? '#67c23a' : '#f56c6c' }">
              {{ parseFloat(scope.row.change_money) >= 0 ? '+' : '' }}{{ scope.row.change_money }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="before_money" label="变动前余额" min-width="120" sortable="custom" align="right" />
        <el-table-column prop="after_money" label="变动后余额" min-width="120" sortable="custom" align="right" />
        <el-table-column prop="type" label="变动类型" min-width="100" sortable="custom" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.type == 1 ? 'success' : 'danger'">
              {{ scope.row.type == 1 ? '收入' : '支出' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="order_id" label="订单ID" min-width="100" sortable="custom" align="center" />
        <el-table-column prop="order_no" label="订单编号" min-width="150" sortable="custom" align="right" />
        <el-table-column prop="order_price" label="订单金额" min-width="120" sortable="custom" align="right" />
        <el-table-column prop="remark" label="备注" min-width="150" align="left">
          <template slot-scope="scope">
            <span>{{ scope.row.remark || '无' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" min-width="170" sortable="custom" align="center" />
      </el-table>
      <div class="table-pagination">
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page="pagination.page" :page-size="pagination.limit" :page-sizes="[10, 20, 50, 100]" :total="pagination.total" @current-change="handlePageChange" @size-change="handleSizeChange" />
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filters: {
        admin_id: "",
        order_id: "",
        order_no: "",
        type: "",
        dateRange: []
      },
      sort: {
        field: "id",
        order: "desc"
      },
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      },
      records: [],
      isSuperAdmin: 0,
      users: []
    };
  },
  computed: {},
  mounted() { },
  created() {
    // 初始化拉取用户记录列表
    this.getUserRecords();
    // 检查当前用户是否为超级管理员
    this.checkSuperAdmin();
  },
  methods: {
    
        // 检查当前用户是否为超级管理员
  checkSuperAdmin() {
      // 从本地存储或接口获取当前用户信息
      this.$http_get('/admin/account/info').then(res => {
        const isSuper = res && res.data ? res.data.is_super : 0;
        this.isSuperAdmin = Number(isSuper) || 0;
        if(this.isSuperAdmin==1){
             this.getUsers();
        }
      })
    },
      // 获取用户列表
    getUsers() {
      this.$http_get('/admin/Agent/all?all=1', 1).then(res => {
        if (res && res.code === 200 && res.data) {
          this.users = res.data.data || [];
        } else {
          console.error('获取用户列表失败:', res);
        }
      }).catch(err => {
        console.error('获取用户列表失败:', err);
      });
    },
    // 获取用户记录列表
    getUserRecords() {
      const query = this.buildQuery({
        page: this.pagination.page,
        limit: this.pagination.limit,
        admin_id: this.filters.admin_id,
        order_id: this.filters.order_id,
        order_no: this.filters.order_no,
        type: this.filters.type,
        start_time: this.filters.dateRange[0] || '',
        end_time: this.filters.dateRange[1] || '',
        sort_field: this.sort.field,
        sort_order: this.sort.order
      });
      this.$http_get(`/admin/finance/moneyLog?${query}`, 1).then(res => {
        if (res && res.code === 200 && res.data) {
          const list = Array.isArray(res.data.data) ? res.data.data : [];
          this.records = list;
          this.pagination.total = Number(res.data.total || 0);
          this.pagination.page = Number(res.data.current_page || this.pagination.page);
          this.pagination.limit = Number(res.data.per_page || this.pagination.limit);
        }
      });
    },
    // 查询
    handleSearch() {
      this.pagination.page = 1;
      this.getUserRecords();
    },
    // 重置
    handleReset() {
      this.filters.admin_id = "";
      this.filters.order_id = "";
      this.filters.order_no = "";
      this.filters.type = "";
      this.filters.dateRange = [];
      this.sort.field = "id";
      this.sort.order = "desc";
      this.pagination.page = 1;
      this.getUserRecords();
    },
    // 切换排序
    handleSortChange({ prop, order }) {
      this.sort.field = prop;
      if (order === "ascending") {
        this.sort.order = "asc";
      } else if (order === "descending") {
        this.sort.order = "desc";
      } else {
        this.sort.order = "desc";
      }
      this.pagination.page = 1;
      this.getUserRecords();
    },
    // 切换页码
    handlePageChange(page) {
      this.pagination.page = page;
      this.getUserRecords();
    },
    // 切换每页条数
    handleSizeChange(size) {
      this.pagination.limit = size;
      this.pagination.page = 1;
      this.getUserRecords();
    },
    // 拼接查询参数
    buildQuery(params) {
      return Object.keys(params)
        .filter(key => params[key] !== "" && params[key] !== null && params[key] !== undefined)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join("&");
    }
  }
};
</script>

<style scoped>
.table-filters {
  margin-bottom: 12px;
}

.table-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.user-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.user-name {
  font-size: 14px;
  font-weight: 500;
}
</style>